import { useEffect } from 'react';
import { ref, set, onDisconnect } from 'firebase/database';
import { rtdb } from '../firebase';
import useAuthStore from '../store/authStore';

export default function useSetOnlineStatus() {
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) {
      console.log('No user found in useSetOnlineStatus');
      return;
    }
    const statusRef = ref(rtdb, `status/${user.uid}`);

    // Set online: true and update lastSeen
    set(statusRef, {
      online: true,
      lastSeen: Date.now(),
    });

    // Set online: false and update lastSeen on disconnect
    onDisconnect(statusRef).set({
      online: false,
      lastSeen: Date.now(),
    });

    // Optionally, set offline on window unload (for extra reliability)
    const handleUnload = () => {
      set(statusRef, {
        online: false,
        lastSeen: Date.now(),
      });
    };
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
      set(statusRef, {
        online: false,
        lastSeen: Date.now(),
      });
    };
  }, [user]);
} 